<template>
  <div style="margin:10px">
    <el-row :gutter="10">
      <el-col :span="elTreeLeftShow?5:0" :xs="24">
        <el-card class="el-card-tree" shadow="hover" :style="{ 'background-color': '#fff', height: cardTreeHeigth}">
          <el-input
            placeholder="请输入关键字过滤"
            v-model="userSearch"
            prefix-icon="el-icon-search"
            size="small"
            clearable
          />
          <div class="div-el-tree" :style="{'height': pageHeight}">
            <el-tree
              class="el-tree-left"
              ref="userTree"
              node-key="nodeId"
              accordion
              style="margin-top:10px;"
              :data="userTree"
              :default-expanded-keys="userTreeDefExpa"
              :props="{ label: 'name', children: 'childs'}"
              :highlight-current="true"
              :expand-on-click-node="false"
              :filter-node-method="onTreeFilter"
              @node-click="onUserTreeClick"
            />
          </div>
        </el-card>
      </el-col>
      <el-col  :span="elTreeLeftShow?19:24" :xs="24" class="el-col-content">
        <i :class="elTreeLeftShow?'el-icon-s-fold':'el-icon-s-unfold'" @click="elTreeLeftShow=!elTreeLeftShow"></i>
        <el-card shadow="hover" style="background-color: #fff">
          <el-row>
            <!-- 查询条件 -->
            <el-col class="pagin" ref="query">
              <el-row class="mb5 mt2 ml2">
                <div class="inline-block mr10">
                  <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">名称:</div>
                  <div class="pl4-6 width-200">
                    <el-input v-model="formQuery.userGwName" size="small" placeholder="名称" clearable></el-input>
                  </div>
                </div>
                <div class="inline-block mr10">
                  <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">识别码:</div>
                  <div class="pl4-6 width-200">
                    <el-input v-model="formQuery.sn" size="small" placeholder="识别码" clearable></el-input>
                  </div>
                </div>
                <div class="inline-block mr10">
                  <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">状态:</div>
                  <div class="pl4-6 width-200">
                    <el-select clearable v-model="formQuery.status" placeholder="请选择状态" size="small">
                      <el-option v-for="(item, index) in dictStatus" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="inline-block mr10" v-if="showMore">
                  <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">在线状态:</div>
                  <div class="pl4-6 width-200">
                    <el-select clearable v-model="formQuery.lineStatus" placeholder="请选择在线状态" size="small">
                      <el-option v-for="(item, index) in dictLineStatus" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="inline-block mr10" v-if="showMore&&userInfo.userLevel=='2'">
                  <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">工厂:</div>
                  <div class="pl4-6 width-200">
                    <el-select v-model="formQuery.userFactId" filterable placeholder="请选择工厂" clearable size="small" class="full" @clear="onSelectClear('userFactIdCacheList')" :filter-method="val=>onSelectFilter(val, formQuery, 'userFactId', 'userFactIdCacheList')">
                        <el-option v-for="(item, index) in userFactIdCacheList" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="inline-block mr10" v-if="showMore&&(userInfo.userLevel=='2'||userInfo.userLevel=='3')">
                  <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">仓库:</div>
                  <div class="pl4-6 width-200">
                    <el-select v-model="formQuery.userStoreId" filterable placeholder="请选择仓库" clearable size="small" class="full" @clear="onSelectClear('userStoreIdCacheList')" :filter-method="val=>onSelectFilter(val, formQuery, 'userStoreId', 'userStoreIdCacheList')">
                        <el-option v-for="(item, index) in userStoreIdCacheList" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="inline-block mr10" v-if="showMore">
                  <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">点位:</div>
                  <div class="pl4-6 width-200">
                    <el-select v-model="formQuery.userPointId" filterable placeholder="请选择点位" clearable size="small" class="full" @clear="onSelectClear('userPointIdCacheList')" :filter-method="val=>onSelectFilter(val, formQuery, 'userPointId', 'userPointIdCacheList')">
                        <el-option v-for="(item, index) in userPointIdCacheList" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="inline-block mr4">
                  <el-button v-if="checkPermission(funcData, 'query')" size="small" type="primary" icon="el-icon-search" @click="onQuery">查找</el-button>
                  <el-button v-if="checkPermission(funcData, 'add')" size="small" type="primary" icon="el-icon-plus" @click="onShowAdd">添加</el-button>
                </div>
                <!-- 批量操作按扭 -->
                <el-dropdown v-if="checkPermission(funcData, 'batchRemove,batchEnable,batchDisable')" size="small" type="primary" trigger="click">
                  <el-button type="primary" size="small">
                    批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="checkPermission(funcData, 'batchRemove')" class="px10" @click.native="onBatchRemove">批量删除</el-dropdown-item>
                    <el-dropdown-item v-if="checkPermission(funcData, 'batchEnable')" class="px10" @click.native="onBatchEnable">批量启用</el-dropdown-item>
                    <el-dropdown-item v-if="checkPermission(funcData, 'batchDisable')" class="px10" @click.native="onBatchDisable">批量禁用</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-switch @change="onRefreshAuto" style="margin-left: 10px;" v-model="refreshAuto" active-text="自动刷新"></el-switch>
                <el-link type="primary" @click="showMore=!showMore" style="margin-left:10px;">{{showMore?'收起∧':'展开∨'}}</el-link>
              </el-row>
              <el-row class="div-level" v-if="divLevel.length > 0">
                <label>层级:</label>
                <span v-for="(tree, index) in divLevel" :key="index"><el-link type="success" @click="onDivClick(tree)">{{tree.name}}</el-link></span>
              </el-row>
            </el-col>

            <!-- 表格  -->
            <el-col v-if="!checkPermission(funcData, 'query')" :style="{height: pageHeight,lineHeight: pageHeight}" class="noPer">没有列表查询权限</el-col>
            <el-col v-else>
              <el-table
                ref="table"
                v-loading="pageLoading"
                element-loading-text="拼命加载中"
                size="mini"
                stripe
                border
                style="width: 100%"
                :height="pageHeight"
                :data="dataList"
                :header-cell-class-name="onHeaderClass"
                @sort-change="onSortChange"
                @selection-change="onSelectionChange"
                ><!-- :default-sort = "{prop: 'date', order: 'descending'}" -->

                <el-table-column
                  v-if="checkPermission(funcData, 'batchRemove,batchEnable,batchDisable')"
                  type="selection"
                  width="45"></el-table-column>

                <el-table-column align="center" label="序号" type="index"></el-table-column>

                <el-table-column width="148px" align="center" label="操作">
                  <template slot-scope="scope">
                    <el-button v-if="checkPermission(funcData, 'detail')" size="mini" title="查看" circle type="success" icon="el-icon-document" @click="onDetail(scope.$index, scope.row)"></el-button>
                    <el-button v-if="checkPermission(funcData, 'modify')" size="mini" title="编辑" circle type="warning" icon="el-icon-edit" @click="onShowEdit(scope.$index, scope.row)"></el-button>
                    <el-button v-if="checkPermission(funcData, 'remove')" size="mini" title="删除" circle type="danger" icon="el-icon-delete" @click="onPageRemove(scope.$index, scope.row)"></el-button>
                    <el-button v-if="checkPermission(funcData, 'userDev')" size="mini" title="设备" circle type="primary" icon="el-icon-odometer" @click="$router.push({name:'userplatDevUserdev', query:{userGwId:scope.row.userGwId}})"></el-button>
                  </template>
                </el-table-column>

                <el-table-column
                  show-overflow-tooltip
                  prop="userGwName"
                  label="名称"
                  sortable="custom"
                  >
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  prop="sn"
                  label="识别码"
                  sortable="custom"
                  >
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  prop="timeTaskDelay"
                  label="定时(s)"
                  sortable="custom"
                  >
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  prop="lineStatus"
                  label="在线状态"
                  sortable="custom"
                  >
                  <template slot-scope="scope">
                    <el-tag size="small" type="warning" v-if="scope.row.lineStatus=='0'">{{scope.row.lineStatus|dict(dictLineStatus)}}</el-tag>
                    <el-tag size="small" type="success" v-else-if="scope.row.lineStatus=='1'">{{scope.row.lineStatus|dict(dictLineStatus)}}</el-tag>
                    <el-tag size="small" v-else-if="scope.row.lineStatus=='2'">{{scope.row.lineStatus|dict(dictLineStatus)}}</el-tag>
                    <el-tag size="small" v-else-if="scope.row.lineStatus=='3'">{{scope.row.lineStatus|dict(dictLineStatus)}}</el-tag>
                    <el-tag size="small" type="danger" v-else-if="scope.row.lineStatus=='4'">{{scope.row.lineStatus|dict(dictLineStatus)}}</el-tag>
                    <el-tag size="small" v-else-if="scope.row.lineStatus=='5'">{{scope.row.lineStatus|dict(dictLineStatus)}}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  prop="status"
                  label="状态"
                  sortable="custom"
                  >
                  <template slot-scope="scope">
                    <el-switch
                      v-if="checkPermission(funcData, 'enable,disable')"
                      :disabled="((scope.row.status!='1' && !checkPermission(funcData, 'enable')) || (scope.row.status=='1' && !checkPermission(funcData, 'disable')))"
                      style="margin-right: 5px;"
                      @change="onSwitch(scope.$index, scope.row)"
                      v-model="scope.row.switch"
                      active-color="#409eff"
                      inactive-color="#dcdfe6">
                    </el-switch>
                    <el-tag size="small" type="success" v-if="scope.row.status == '1'">{{scope.row.status|dict(dictStatus)}}</el-tag>
                    <el-tag size="small" type="danger" v-else>{{scope.row.status|dict(dictStatus)}}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  prop="updateTime"
                  label="更新时间"
                  sortable="custom"
                  >
                </el-table-column>
              </el-table>
            </el-col>

            <!-- 分页 -->
            <el-col class="pagination">
              <el-pagination
                background
                :current-page="pageParam.pageNo"
                :page-sizes="[30, 50, 100, 200, 500, 1000]"
                @size-change="onSizeChange"
                @current-change="onCurrentChange"
                layout="prev, pager, next, total, jumper, sizes"
                :total="pageTotal">
              </el-pagination>
            </el-col>
          </el-row>

        </el-card>
      </el-col>
    </el-row>

    <!-- 详情弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogDetail" width="1000px" top="8vh">
      <template slot="title"><i class="el-icon-document" /> 网关设备详情</template>
      <el-descriptions class="detail-div" :column="3" size="small" border labelClassName="detail-label" contentClassName="detail-content">
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-warning-outline"></i>网关ID</template>
          {{dataDetail.userGwId}}
        </el-descriptions-item>
        <el-descriptions-item span="2">
          <template slot="label"><i class="el-icon-tickets"></i>网关名称</template>
          {{dataDetail.userGwName}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-tickets"></i>网关描叙</template>
          {{dataDetail.userGwDesc}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-warning-outline"></i>厂商网关</template>
          {{dataDetail.produerId|dict(produerIdCacheListCopy)}}
          >
          {{dataDetail.gwId|dict(gwIdCacheListCopy)}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-warning-outline"></i>商户网关</template>
          {{dataDetail.merId|dict(merIdCacheListCopy)}}
          >
          {{dataDetail.merGwId|dict(merGwIdCacheListCopy)}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-user-solid"></i>点位</template>
          {{dataDetail.userFactId|dict(userFactIdCacheListCopy)}}
          >
          {{dataDetail.userStoreId|dict(userStoreIdCacheListCopy)}}
          >
          {{dataDetail.userPointId|dict(userPointIdCacheListCopy)}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-office-building"></i>安装地址</template>
          {{dataDetail.addr}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-tickets"></i>识别码</template>
          {{dataDetail.sn}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-tickets"></i>报警公式</template>
          {{dataDetail.alertExp}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-tickets"></i>定时任务</template>
          {{dataDetail.timeTask}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-tickets"></i>在线说明</template>
          {{dataDetail.lineDesc}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-tickets"></i>在线信息</template>
          {{dataDetail.lineMsg}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-key"></i>网关密码</template>
          {{dataDetail.userGwPwd}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-tickets"></i>定时(s)</template>
          {{dataDetail.timeTaskDelay}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-open"></i>状态</template>
          {{dataDetail.status|dict(dictStatus)}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-open"></i>在线状态</template>
          {{dataDetail.lineStatus|dict(dictLineStatus)}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-user-solid"></i>最后操作员</template>
          {{dataDetail.operatorId}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-time"></i>创建时间</template>
          {{dataDetail.createTime}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-time"></i>更新时间</template>
          {{dataDetail.updateTime}}
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogDetail=false" size="small">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 添加弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogAdd" width="700px" @closed="onResetForm('formAdd')" top="8vh">
      <template slot="title"><i class="el-icon-document-add" /> 添加网关设备</template>
      <el-form :model="formAdd" ref="formAdd" :rules="formAddRules" size="small" inline label-width="110px">
        <el-form-item label="网关名称" prop="userGwName">
          <el-input class="width-2-2" v-model="formAdd.userGwName" placeholder="请输入网关名称" maxlength="64" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="网关描叙" prop="userGwDesc">
          <el-input class="width-2-2" type="textarea" v-model="formAdd.userGwDesc" placeholder="请输入网关描叙" maxlength="256" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="商户网关" prop="merGwId">
          <select-tree class="width-2-2" ref="merGwIdAddTree" :options="merGwIdCacheTreeList" :defaultProps="pageDefaultProps" @input="merGwIdOnAddSelect" :multiple="false"></select-tree>
        </el-form-item>
        <el-form-item label="点位" prop="userPointId">
          <select-tree class="width-2-2" ref="userPointIdAddTree" :options="userPointIdCacheTreeList" :defaultProps="pageDefaultProps" @input="userPointIdOnAddSelect" :multiple="false"></select-tree>
        </el-form-item>
        <el-form-item label="安装地址" prop="addr">
          <el-input class="width-2-2" v-model="formAdd.addr" placeholder="请输入安装地址" maxlength="512" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="网关密码" prop="userGwPwd">
          <el-input class="width-2-2" v-model="formAdd.userGwPwd" placeholder="请输入网关密码" maxlength="256" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="识别码" prop="sn">
          <el-input class="width-2-2" v-model="formAdd.sn" placeholder="请输入识别码" maxlength="256" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="报警公式" prop="alertExp">
          <el-input class="width-2-2" v-model="formAdd.alertExp" placeholder="请输入报警公式" maxlength="1048" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="定时(s)" prop="timeTaskDelay">
          <el-input class="width-2-2" v-model="formAdd.timeTaskDelay" placeholder="请输入定时(s)" clearable></el-input>
        </el-form-item>
        <el-form-item label="定时任务" prop="timeTask">
          <el-input class="width-2-2" v-model="formAdd.timeTask" placeholder="请输入定时任务" maxlength="4096" show-word-limit clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmitAdd()" size="small">提 交</el-button>
        <el-button @click="dialogAdd=false" size="small">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 编辑弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogModify" width="700px" @opened="onEditTreeInit" @closed="onResetForm('formEdit')" top="8vh">
      <template slot="title"><i class="el-icon-edit" /> 编辑网关设备</template>
      <el-form :model="formEdit" ref="formEdit" :rules="formEditRules" size="small" inline label-width="110px">
        <el-form-item label="网关名称" prop="userGwName">
          <el-input class="width-2-2" v-model="formEdit.userGwName" placeholder="请输入网关名称" maxlength="64" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="网关描叙" prop="userGwDesc">
          <el-input class="width-2-2" type="textarea" v-model="formEdit.userGwDesc" placeholder="请输入网关描叙" maxlength="256" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="商户网关" prop="merGwId">
          <select-tree class="width-2-2" ref="merGwIdEditTree" :options="merGwIdCacheTreeList" :EObjArr="merGwIdEditTreeDef" :defaultProps="pageDefaultProps" @input="merGwIdOnEditSelect" :multiple="false"></select-tree>
        </el-form-item>
        <el-form-item label="点位" prop="userPointId">
          <select-tree class="width-2-2" ref="userPointIdEditTree" :options="userPointIdCacheTreeList" :EObjArr="userPointIdEditTreeDef" :defaultProps="pageDefaultProps" @input="userPointIdOnEditSelect" :multiple="false"></select-tree>
        </el-form-item>
        <el-form-item label="安装地址" prop="addr">
          <el-input class="width-2-2" v-model="formEdit.addr" placeholder="请输入安装地址" maxlength="512" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="网关密码" prop="userGwPwd">
          <el-input class="width-2-2" v-model="formEdit.userGwPwd" placeholder="请输入网关密码" maxlength="256" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="识别码" prop="sn">
          <el-input class="width-2-2" v-model="formEdit.sn" placeholder="请输入识别码" maxlength="256" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="报警公式" prop="alertExp">
          <el-input class="width-2-2" v-model="formEdit.alertExp" placeholder="请输入报警公式" maxlength="1048" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="定时(s)" prop="timeTaskDelay">
          <el-input class="width-2-2" v-model="formEdit.timeTaskDelay" placeholder="请输入定时(s)" clearable></el-input>
        </el-form-item>
        <el-form-item label="定时任务" prop="timeTask">
          <el-input class="width-2-2" v-model="formEdit.timeTask" placeholder="请输入定时任务" maxlength="4096" show-word-limit clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmitEdit()" size="small">提 交</el-button>
        <el-button @click="onResetEdit" size="small">重 置</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios' // 引入页面处理
import selectTree from '@/components/selectTreeObj.vue' // 引入下拉树

export default {
  name: 'userplatDevUsergw',
  components: { // 组件
    selectTree // 关联下拉树
  },
  data () {
    return {
      menuName: 'userplatDevUsergw',
      cardTreeHeigth: window.innerHeight - 100 + 'px',
      formQuery: { // 查询对象
        userGwName: '', // 网关名称
        sn: '', // 识别码
        status: '', // 状态
        lineStatus: '', // 在线状态
        userFactId: '', // 工厂
        userStoreId: '', // 仓库
        userPointId: '' // 点位
      },
      formAdd: { // 新增对象
        userGwName: '', // 网关名称
        userGwDesc: '', // 网关描叙
        produerId: '', // 厂商
        gwId: '', // 厂商网关
        merId: '', // 商户
        merGwId: '', // 商户网关
        userFactId: '', // 工厂
        userStoreId: '', // 仓库
        userPointId: '', // 点位
        addr: '', // 安装地址
        userGwPwd: '', // 网关密码
        sn: '', // 识别码
        alertExp: '', // 报警公式
        timeTaskDelay: '', // 定时(s)
        timeTask: '' // 定时任务
      },
      formAddRules: { // 新增规则
        userGwName: [{ required: true, message: '请输入网关名称', trigger: 'blur' }],
        merGwId: [{ required: true, message: '请输入商户网关', trigger: 'blur' }],
        userPointId: [{ required: true, message: '请输入点位', trigger: 'blur' }],
        sn: [{ required: true, message: '请输入识别码', trigger: 'blur' }]
      },
      formEditRules: { // 更新规则
        userGwName: [{ required: true, message: '请输入网关名称', trigger: 'blur' }],
        merGwId: [{ required: true, message: '请输入商户网关', trigger: 'blur' }],
        userPointId: [{ required: true, message: '请输入点位', trigger: 'blur' }],
        sn: [{ required: true, message: '请输入识别码', trigger: 'blur' }]
      },
      dictStatus: [], // 状态
      dictLineStatus: [], // 在线状态
      produerIdCacheList: [],
      produerIdCacheListCopy: [],
      gwIdCacheList: [],
      gwIdCacheListCopy: [],
      merIdCacheList: [],
      merIdCacheListCopy: [],
      merGwIdCacheList: [],
      merGwIdCacheListCopy: [],
      userFactIdCacheList: [],
      userFactIdCacheListCopy: [],
      userStoreIdCacheList: [],
      userStoreIdCacheListCopy: [],
      userPointIdCacheList: [],
      userPointIdCacheListCopy: [],
      merGwIdCacheTreeList: [],
      merGwIdCacheTreeListCopy: [],
      userPointIdCacheTreeList: [],
      userPointIdCacheTreeListCopy: [],
      merGwIdEditTreeDef: [],
      userPointIdEditTreeDef: [],
      idName: 'userGwId',
      httpUrl: '/dev/userGw',
      httpUri: {
        produerIdCacheUri: '/cache/devProd',
        gwIdCacheUri: '/cache/devGw',
        merIdCacheUri: '/cache/merInfo',
        merGwIdCacheUri: '/cache/merGw',
        userFactIdCacheUri: '/cache/userFactory',
        userStoreIdCacheUri: '/cache/userStore',
        userPointIdCacheUri: '/cache/userPoint',
        merGwIdCacheTreeUri: '/cacheTree/merGw',
        userPointIdCacheTreeUri: '/cacheTree/userPoint',
        userTree: '/user/userTree/point'
      },
      divLevel: [],
      divTree: {},
      refreshSpace: 5000,
      refreshTimer: null,
      refreshAuto: false,
      userTree: [],
      userTreeDefExpa: [],
      userSearch: '',
      devSearch: '',
      merSearch: '',
      elTreeLeftShow: false
    }
  },
  watch: {
    'formQuery.userFactId': {
      handler (curVal, oldVal) {
        this.onSelectChange(curVal, 'userFactIdCacheList', 'userStoreIdCacheList', this.httpUri.userStoreIdCacheUri, this.formQuery, 'userStoreId', true, { userFactId: curVal })
      }
    },
    'formQuery.userStoreId': {
      handler (curVal, oldVal) {
        this.onSelectChange(curVal, 'userStoreIdCacheList', 'userPointIdCacheList', this.httpUri.userPointIdCacheUri, this.formQuery, 'userPointId', true, { userStoreId: curVal })
      }
    },
    $route (to, from) {
      this.routeTree(to)
    },
    userSearch (val) {
      this.$refs.userTree.filter(val)
    }
  },
  mounted () {
    this.mountedTree()
    if (Object.keys(this.$route.query).length) {
      this.httpQuery()
    }
    this.getSysDict('STATUS_TYPE', 'dictStatus', 'getStatus')
    this.getSysDict('LINE_STATUS', 'dictLineStatus', 'getLineStatus')
    this.httpSelectList('produerIdCacheList', this.httpUri.produerIdCacheUri)
    this.httpSelectList('gwIdCacheList', this.httpUri.gwIdCacheUri)
    this.httpSelectList('merIdCacheList', this.httpUri.merIdCacheUri)
    this.httpSelectList('merGwIdCacheList', this.httpUri.merGwIdCacheUri)
    this.httpSelectList('userFactIdCacheList', this.httpUri.userFactIdCacheUri)
    this.httpSelectList('userStoreIdCacheList', this.httpUri.userStoreIdCacheUri)
    this.httpSelectList('userPointIdCacheList', this.httpUri.userPointIdCacheUri)
    this.httpSelectList('merGwIdCacheTreeList', this.httpUri.merGwIdCacheTreeUri)
    this.httpSelectList('userPointIdCacheTreeList', this.httpUri.userPointIdCacheTreeUri)
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
    this.httpUserTree()
  },
  activated () {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
    if (this.refreshAuto) {
      this.refreshTimer = window.setInterval(this.httpQuery, this.refreshSpace)
    }
  },
  deactivated () {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  },
  beforeDestroy () {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  },
  methods: {
    onQuery () {
      const [id, type] = this.getQuery()
      this.getDivLevel(id, type)
      this.onPageQuery()
    },
    onUserTreeClick (data) {
      let type = data.type
      let id = data.id
      this.getDivLevel(id, type)
      this.putQuery(id, type)
      this.httpQuery()
    },
    onTreeFilter (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    onAddTreeInit () {
      this.$refs.merGwIdAddTree.init()
      this.$refs.userPointIdAddTree.init()
    },
    merGwIdOnAddSelect (node, val) {
      this.formAdd.merGwId = node.value
      this.formAdd.produerId = node.params.produerId
      this.formAdd.merId = node.params.merId
      this.formAdd.gwId = node.params.gwId
    },
    userPointIdOnAddSelect (node, val) {
      this.formAdd.userPointId = node.value
      this.formAdd.userStoreId = node.params.userStoreId
      this.formAdd.userFactId = node.params.userFactId
    },
    onEditTreeDefInit (data) {
      this.merGwIdEditTreeDef = this.getTreeDef(this.merGwIdCacheTreeList, data.merGwId)
      this.userPointIdEditTreeDef = this.getTreeDef(this.userPointIdCacheTreeList, data.userPointId)
    },
    onEditTreeInit () {
      this.$refs.merGwIdEditTree.init()
      this.$refs.userPointIdEditTree.init()
    },
    merGwIdOnEditSelect (node, val) {
      this.formEdit.merGwId = node.value
      this.formEdit.produerId = node.params.produerId
      this.formEdit.merId = node.params.merId
      this.formEdit.gwId = node.params.gwId
    },
    userPointIdOnEditSelect (node, val) {
      this.formEdit.userPointId = node.value
      this.formEdit.userStoreId = node.params.userStoreId
      this.formEdit.userFactId = node.params.userFactId
    },
    onRefreshAuto (val) {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer)
      }
      if (val) {
        this.refreshTimer = window.setInterval(this.httpQuery, this.refreshSpace)
      }
    },
    httpUserTree () {
      axios({
        url: this.baseUrl + this.httpUri.userTree,
        method: 'get'
      }).then(res => {
        if (res.data.code === '0000') {
          this.userTree = res.data.data
          this.getDivLevel(this.divTree.id, this.divTree.type)
        }
      }).catch(err => {
        console.log(err, 'loginerr')
      })
    },
    removeTip (row) {
      return `网关名称：${row.userGwName}<br/>识别码：${row.sn}<br/>确认要删除该网关？`
    }
  }
}
</script>

<style scoped>
@import "../../assets/page.css";

div.width-2-2 {
    width: 520px;
}
</style>
